module.exports = __webpack_public_path__ + "static/media/france.bcd389de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/flag/france.svg
// module id = 2251
// module chunks = 0